import { get, post, put, del, search } from 'redux/shelf/api';
import session from 'lib/session';
import { createReducer } from 'redux/shelf';

export const actions = {
  getCollectionsAutoSyncStatus: get`smart-collections/auto-sync`(),
  enableCollectionsAutoSync: post`smart-collections/auto-sync`(),
  disableCollectionsAutoSync: del`smart-collections/auto-sync`()
}

export const reducer = createReducer(actions, {
  [actions.getCollectionsAutoSyncStatus]: (s, { payload, meta }) => ({
    ...s,
    entity: payload.entity.enabled
  }),
  [actions.enableCollectionsAutoSync]: (s) => ({
    ...s,
    entity: true
  }),
  [actions.disableCollectionsAutoSync]: (s) => ({
    ...s,
    entity: false
  })
});